import scrollManager from '../utils/scrollManager'

export default {
  name: 'header',

  isOpen: false,

  ui: {
    burger: '[js-header-burger]',
    navWrap: '[js-header-nav-wrap]',
    'togglePanels[]': '[js-header-toggle-panel]',
    'toggleSubnavs[]': '[js-header-toggle-subnav]',
    'back[]': '[js-header-back]',
    'backPanel[]': '[js-header-back-panel]',
    'subnavs[]': '[js-header-subnav]',
    profiles: '[js-header-profiles]',
  },

  events: [
    {
      target: 'burger',
      on: 'click',
      handle (e) {
        this.ui.burger.classList.toggle('is-active')
        this.ui.navWrap.classList.toggle('is-opened')

        this.isOpen = !this.isOpen

        this.isOpen ? scrollManager.stop() : scrollManager.restart()

        // close actions
        if (!this.isOpen) {
          setTimeout(() => {
            this.ui.profiles.style.height = 0
          }, 400)

          this.ui.subnavs.forEach(subnav => {
            subnav.classList.remove('is-active')
          })

          if (document.querySelector('.header__panel.is-active')) {
            document.querySelector('.header__panel.is-active').classList.remove('is-active')
          }
        }
      },
    },
    {
      target: 'togglePanels',
      on: 'click',
      handle (e) {
        const panel = e.target.parentNode.querySelector('[js-header-panel]')

        if (window.innerWidth >= 1024) {
          if (this.isOpen) {
            if (document.querySelector('.header__panel.is-active')) {
              document.querySelector('.header__panel.is-active').classList.remove('is-active')
            }

            if (document.querySelector('.main-nav__link.is-active')) {
              document.querySelector('.main-nav__link.is-active').classList.remove('is-active')
            }
          } else {
            this.isOpen = !this.isOpen
            this.isOpen ? scrollManager.stop() : scrollManager.restart()
          }

          if (panel.querySelector('.subnav--start')) {
            panel.querySelector('.header__panel-inner').style.height = `${panel.querySelector('.subnav--start').offsetHeight}px`
          }

          if (!this.isOpen) {
            this.closePanels(panel)
          }
        } else {
          if (e.target.classList.contains('main-nav__link')) {
            setTimeout(() => {
              this.ui.profiles.style.height = 0
            }, 400)
          }

          this.isOpen = !this.isOpen
        }

        e.target.classList.toggle('is-active')
        panel.classList.toggle('is-active')
      },
    },
    {
      target: 'toggleSubnavs',
      on: 'click',
      handle (e) {
        const subnav = e.target.nextElementSibling
        subnav.classList.add('is-active')

        if (window.innerWidth >= 1024) {
          e.target.closest('.header__panel-inner').style.height = `${subnav.offsetHeight}px`
        }
      },
    },
    {
      target: 'back',
      on: 'click',
      handle (e) {
        const currentSubnav = e.target.closest('.subnav')
        currentSubnav.classList.remove('is-active')

        if (window.innerWidth >= 1024) {
          e.target.closest('.header__panel-inner').style.height = `${currentSubnav.parentNode.closest('.subnav').offsetHeight}px`
        }
      },
    },
    {
      target: 'backPanel',
      on: 'click',
      handle (e) {
        e.target.closest('[js-header-panel]').classList.remove('is-active')
      },
    },
  ],

  componentDidMount () {
    document.body.addEventListener('click', (e) => {
      if (window.innerWidth >= 1024 && this.isOpen && !e.target.classList.contains('search-panel-toggle') && !e.target.classList.contains('main-nav__link') && !e.target.classList.contains('header__button--medium-blue') && e.target.closest('.header__panel-inner') === null && !e.target.classList.contains('header__panel-inner')) {
        const activePanel = document.querySelector('.header__panel.is-active')
        activePanel.classList.remove('is-active')

        if (document.querySelector('.main-nav__link.is-active')) {
          document.querySelector('.main-nav__link.is-active').classList.remove('is-active')
        }

        scrollManager.restart()
        this.isOpen = false

        this.closePanels(activePanel)
      }
    })
  },

  closePanels (panel) {
    setTimeout(() => {
      this.ui.subnavs.forEach(subnav => {
        subnav.classList.remove('is-active')
      })

      if (window.innerWidth >= 1024 && panel.querySelector('.subnav--start')) {
        panel.querySelector('.header__panel-inner').style.height = `${panel.querySelector('.subnav--start').offsetHeight}px`
      }
    }, 300)
  },
}
